module.exports = __webpack_public_path__ + "img/bg_seat_tablet.84eeb299.jpg";